<template>
  <div class="row justify-content-center" v-if="!setHide">
    <div class="col-md-8">
      <Loading v-if="showLoading" />
      <div class="card mb-3 pt-3">
        <form class="row m-0" v-on:submit.prevent="">
          <div class="col-md-6">
            <div class="form-group">
              <label>نام فارسی سازمان</label>
              <input
                type="text"
                class="form-control"
                v-model="company.companyNameFa"
              />
            </div>
          </div>

          <!-- <div class="col-md-6">
                        <div class="form-group">
                            <label>نام انگلیسی سازمان</label>
                            <input type="text" class="form-control ltr-input" v-model="company.companyNameEn">
                        </div>
                    </div> -->
          <div class="col-md-6" v-if="shahkarVerify && realInquiryVerify">
            <div class="form-group">
              <label>شناسه ملی</label>
              <input
                type="tel"
                class="form-control ltr-input"
                v-mask="'###########'"
                v-model="company.nationalId"
              />
            </div>
          </div>
          <div class="col-md-6" v-if="shahkarVerify && realInquiryVerify">
            <div class="form-group">
              <label>شماره ثبت</label>
              <input
                type="tel"
                class="form-control ltr-input"
                v-mask="'#######'"
                v-model="company.registryNo"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>کد ملی مسئول</label>
              <input
                type="tel"
                class="form-control ltr-input"
                v-mask="'##########'"
                v-model="company.agentNationalNo"
              />
            </div>
          </div>
          <div
            class="col-md-6"
            v-if="realInquiryVerify && company.agentFirstName"
          >
            <div class="form-group">
              <label>نام مسئول</label>
              <p class="form-control">{{ company.agentFirstName }}</p>
            </div>
          </div>
          <div
            class="col-md-6"
            v-if="realInquiryVerify && company.agentLastName"
          >
            <div class="form-group">
              <label>نام خانوادگی مسئول</label>
              <p class="form-control">{{ company.agentLastName }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>شماره همراه مسئول</label>
              <input
                type="tel"
                class="form-control ltr-input"
                v-mask="'####-#######'"
                v-model="company.agentMobile"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>تاریخ تولد مسئول</label>
              <Datepicker
                locale="fa"
                :auto-submit="true"
                v-model="company.agentBirthdate"
                :locale-config="{
                  fa: {
                    displayFormat: 'jYYYY/jMM/jDD',
                    lang: { label: 'شمسی' },
                  },
                }"
              />
            </div>
          </div>
          <!-- <div class="col-md-4">
                        <div class="form-group">
                            <label>ایمیل مسئول</label>
                            <input type="email" class="form-control ltr-input" v-model="company.agentEmail">
                        </div>
                    </div> -->
          <!-- <div class="col-md-4">
                        <div class="form-group">
                            <label>شماره تماس (همراه با کد شهر)</label>
                            <input type="tel" class="form-control ltr-input" v-mask="'###-########'"
                                v-model="company.phone">
                        </div>
                    </div> -->
          <!-- <div class="col-md-6">
                        <div class="form-group">
                            <label>رمز عبور</label>
                            <input type="password" class="form-control ltr-input" v-model="company.password">
                        </div>
                    </div> -->
          <!-- <div class="col-md-6">
                        <div class="form-group">
                            <label>تکرار رمز عبور</label>
                            <input type="password" class="form-control ltr-input" v-model="company.confirmPassword">
                        </div>
                    </div> -->
          <!-- <div class="col-md-3" v-if="$store.state.role == 'admin'">
                        <div class="form-group">
                            <label>سوییچ صادرکننده</label>
                            <select class="form-control" v-model="company.provider">
                                <option value="" selected disabled>انتخاب کنید</option>
                                <option v-for="(provider,index) in providers" :key="index" :value="provider.id">{{
                                    provider.title }}</option>
                            </select>
                        </div>
                    </div> -->
          <!-- <div class="col-md-12" v-if="$store.state.role == 'admin'">
                        <label class="custom-switch mb-3">
                            <input type="checkbox" name="custom-switch-checkbox" class="custom-switch-input"
                                v-model="company.tourism">
                            <span class="custom-switch-indicator"></span>
                            <span class="custom-switch-description">سازمان از نوع گردشگری می باشد</span>
                        </label>
                    </div> -->
          <!-- <div class="col-md-12" v-if="$store.state.role == 'admin'">
                        <label class="custom-switch mb-3">
                            <input type="checkbox" name="custom-switch-checkbox2" class="custom-switch-input"
                                v-model="company.createWallet">
                            <span class="custom-switch-indicator"></span>
                            <span class="custom-switch-description">ایجاد کیف پول برای سازمان</span>
                        </label>
                    </div> -->
          <!-- <div class="col-md-6" v-if="company.createWallet">
                        <div class="form-group">
                            <label>شماره حساب</label>
                            <input type="tel" class="form-control ltr-input" v-mask="'####################'"
                                v-model="company.accountNumber">
                        </div>
                    </div> -->
          <!-- <div class="col-md-6" v-if="company.createWallet">
                        <div class="form-group">
                            <label>شماره شبا</label>
                            <input type="tel" class="form-control ltr-input" v-mask="'IR########################'"
                                v-model="company.iBan">
                        </div>
                    </div> -->
          <!-- <div class="col-md-12" v-if="$store.state.role == 'admin'">
                        <label class="custom-switch mb-3">
                            <input type="checkbox" name="custom-switch-checkbox3" class="custom-switch-input"
                                v-model="company.fidaConsumerAllow">
                            <span class="custom-switch-indicator"></span>
                            <span class="custom-switch-description"> آیا برای این سازمان دسترسی کد فیدا (اتباع خارجی ) وجود
                                داشته باشد ؟ </span>
                        </label>
                    </div> -->
          <!-- <div class="verification-status mb-3" v-if="triedVerify">
            <div
              class="status-item text-center"
              :class="{
                'text-success': shahkarVerify,
                'text-danger': !shahkarVerify,
              }"
            >
              <i
                :class="
                  shahkarVerify ? 'fa fa-check-circle' : 'fa fa-times-circle'
                "
              ></i>
              <span>استعلام شاهکار</span>
            </div>
            <div
              class="status-item text-center mt-1"
              :class="{
                'text-success': realInquiryVerify,
                'text-danger': !realInquiryVerify,
              }"
            >
              <i
                :class="
                  realInquiryVerify
                    ? 'fa fa-check-circle'
                    : 'fa fa-times-circle'
                "
              ></i>
              <span>استعلام ثبت احوال</span>
            </div>
          </div>
          <div class="col-md-12 mb-3">
            <button
              class="btn btn-warning"
              @click="verify"
              v-if="!shahkarVerify || !realInquiryVerify"
            >
              استعلام
            </button>
            <button
              class="btn btn-success"
              @click="submit"
              v-if="shahkarVerify && realInquiryVerify"
            >
              ایجاد سازمان
            </button>
          </div> -->
        </form>
        <div
          class="row"
          style="justify-content: center; margin-top: 1rem; margin-bottom: 1rem;"
        >
          <div
            class="d-flex flex-column align-items-center"
            style="width: 100%;"
          >
            <!-- وضعیت استعلام‌ها -->
            <div class="verification-status mb-3" v-if="triedVerify">
              <div
                class="status-item text-center"
                :class="{
                  'text-success': shahkarVerify,
                  'text-danger': !shahkarVerify,
                }"
              >
                <i
                  :class="
                    shahkarVerify ? 'fa fa-check-circle' : 'fa fa-times-circle'
                  "
                ></i>
                <span>استعلام شاهکار</span>
              </div>
              <div
                class="status-item text-center mt-1"
                :class="{
                  'text-success': realInquiryVerify,
                  'text-danger': !realInquiryVerify,
                }"
              >
                <i
                  :class="
                    realInquiryVerify
                      ? 'fa fa-check-circle'
                      : 'fa fa-times-circle'
                  "
                ></i>
                <span>استعلام ثبت احوال</span>
              </div>
            </div>

            <!-- دکمه‌ها -->
            <div
              style="width: 100%; max-width: 300px;"
              v-if="!shahkarVerify || !realInquiryVerify"
            >
              <button
                class="btn btn-warning w-full"
                style="width: 100%;"
                @click="verify"
                type="button"
              >
                استعلام
              </button>
            </div>
            <div
              style="width: 100%; max-width: 300px;"
              v-if="shahkarVerify && realInquiryVerify"
            >
              <button
                class="btn btn-success w-full"
                style="width: 100%;"
                @click="submit"
                type="button"
              >
                ایجاد سازمان
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.verification-status {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  gap: 4px;
  margin-top: 1.6rem;
}
.status-item {
  font-size: 0.9rem;
  white-space: nowrap;
}
.status-item i {
  margin-left: 6px;
  font-size: 1rem;
}
</style>

<script>
export default {
  name: "Organization",
  props: ["closed", "search", "companyNationalId"],
  data() {
    return {
      showLoading: false,
      providers: [],
      company: {
        companyNameFa: "",
        companyNameEn: "",
        nationalId: "",
        registryNo: "",
        agentFirstName: "",
        agentLastName: "",
        agentNationalNo: "",
        agentMobile: "",
        agentEmail: "",
        agentBirthdate: "",
        phone: "",
        password: "",
        confirmPassword: "",
        provider: "",
        tourism: false,
        createWallet: false,
        accountNumber: "",
        iBan: "",
        fidaConsumerAllow: false,
      },
      setHide: false,
      shahkarVerify: false,
      realInquiryVerify: false,
      triedVerify: false,
    };
  },
  mounted() {
    if (this.companyNationalId) {
      this.company.nationalId = this.companyNationalId;
    }
  },
  methods: {
    getData() {
      this.$api.get("Organizations/Issuers").then(({ data }) => {
        if (data.status) this.providers = data.result;
      });
    },
    async verify() {
      try {
        this.showLoading = true;

        // Reset flags at the beginning
        this.shahkarVerify = false;
        this.realInquiryVerify = false;
        const verifyPayload = {
          nationalCode: this.company.agentNationalNo,
          mobileNumber: this.company.agentMobile.replace("-", ""),
          birthDate: this.company.agentBirthdate.replaceAll("/", ""),
        };

        const shahkarRes = await this.$api.post(
          "Customer/Shahkar",
          verifyPayload,
        );
        if (shahkarRes.data.result && shahkarRes.data.status) {
          this.shahkarVerify = true;
        } else {
          // اگر تأیید نشد، می‌توان خطا داد یا خروج کرد
          this.$swal({
            title: "ناموفق",
            icon: "error",
            text: "استعلام شاهکار ناموفق بود",
          });
          return;
        }

        const realInquiryRes = await this.$api.post(
          "Customer/RealInquiry",
          verifyPayload,
        );
        if (realInquiryRes.data.status) {
          this.realInquiryVerify = true;
          this.company.agentFirstName = realInquiryRes.data.result.firstName;
          this.company.agentLastName = realInquiryRes.data.result.lastName;
        }
      } finally {
        this.showLoading = false;
        this.triedVerify = true;
      }
    },
    submit() {
      this.showLoading = true;
      const postedData = {
        ...this.company,
        agentMobile: this.company.agentMobile.replace("-", ""),
        agentBirthdate: this.company.agentBirthdate.replaceAll("/", ""),
        // tourism: this.company.tourism,
        // createWallet: this.company.createWallet,
        // fidaConsumerAllow: this.company.fidaConsumerAllow,
        // phone: this.company.phone.replace("-", ""),
        // cardIssuerId: this.company.provider,
      };
      this.$api
        .post("Management/RegisterLegalCustomer", postedData)
        .then(({ data }) => {
          if (data.status) {
            this.$swal({
              title: "تبریک",
              icon: "success",
              text: "سازمان با موفقیت ایجاد شد",
            }).then(() => {
              this.company = {
                companyNameFa: "",
                companyNameEn: "",
                nationalId: "",
                registryNo: "",
                agentFirstName: "",
                agentLastName: "",
                agentNationalNo: "",
                agentMobile: "",
                agentEmail: "",
                phone: "",
                password: "",
                createWallet: false,
                fidaConsumerAllow: false,
                confirmPassword: "",
                accountNumber: "",
                iban: "",
              };
              if (this.closed) {
                this.setHide = true;
                this.search();
              } else this.$router.push({ name: "organizations" });
            });
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>
